import {
  DashboardApiFp,
  DashboardControllerDashboard200Response,
  DashboardControllerGetPatientSummary200Response,
  DashboardControllerGetTotalExpectedBookingRevenuePatients200Response,
  DashboardControllerGetUpcomingSessions200Response,
  DashboardDto,
  DashboardPatientDto,
  DashboardPatientSummaryDto,
  DashboardUpcomingSessionDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";
import { Query } from "react-query";

export type GetResponseDashboardModel = DashboardControllerDashboard200Response;
export type GetDashboardModel = DashboardDto;
export type GetDashboardPatientModel = DashboardPatientDto;
export type GetDashboardPatientSummaryModel = DashboardPatientSummaryDto;
export type GetResponseDashboardPatientsModel = DashboardControllerGetTotalExpectedBookingRevenuePatients200Response;
export type GetResponseDashboardPatientSummaryModel = DashboardControllerGetPatientSummary200Response;
export type GetDashboardUpcomingSessionModel = DashboardUpcomingSessionDto;
export type GetResponseDashboardUpcomingSessionsModel = DashboardControllerGetUpcomingSessions200Response;

export const apiDashboardFp = DashboardApiFp(apiConfig);
export const getDashboardController =
  apiDashboardFp.dashboardControllerDashboard;
export const getTotalExpectedBookingRevenuePatientsController =
  apiDashboardFp.dashboardControllerGetTotalExpectedBookingRevenuePatients;
export const getTotalPaidPatientsController =
  apiDashboardFp.dashboardControllerGetTotalPaidPatients;
export const getTotalPendingPatientsController =
  apiDashboardFp.dashboardControllerGetTotalPendingPatients;
export const getPatientSummaryController =
  apiDashboardFp.dashboardControllerGetPatientSummary;
export const getUpcomingSessionsController =
  apiDashboardFp.dashboardControllerGetUpcomingSessions;

export const QueryKeyDashboard = QueryKey.Dashboard;
export const QueryKeyDashboardExpectedRevenuePatients = "DashboardExpectedRevenuePatients";
export const QueryKeyDashboardPaidPatients = "DashboardPaidPatients";
export const QueryKeyDashboardPendingPatients = "DashboardPendingPatients";
export const QueryKeyDashboardPatientSummary = "DashboardPatientSummary";
export const QueryKeyDashboardUpcomingSessions = "DashboardUpcomingSessions";

// Every dashboard query key above starts with "Dashboard"; used to mark them
// all stale after any successful write (see main-app.tsx).
export const isDashboardQuery = (query: Query) =>
  Array.isArray(query.queryKey) &&
  typeof query.queryKey[0] === "string" &&
  query.queryKey[0].startsWith(QueryKeyDashboard);
